import moment from 'moment'
import React from 'react'

import { Occurence } from '../../domain/Error'
import Chart from '../../monitor/histogram.d3'

import dateFormatter from '../../helper/dateFormatter'
import { ErrorHistogramTimerangeSelector } from './ErrorHistogramTimerangeSelector'
import { observeElement, unobserveElement } from '../../helper/resizeObserver'

interface Props {
    occurrences: Occurence[]
    height: number
    errorGroupId: string
}

export class ErrorHistogram extends React.Component<Props> {
    public static defaultProps = {
        height: 120,
    }

    public nodes: { svg: SVGSVGElement | null } = { svg: null }
    public chart
    public resizeObserver

    private readonly svgRef: React.RefObject<SVGSVGElement>

    constructor(props: Props, context: unknown) {
        super(props, context)
        this.svgRef = React.createRef()
    }

    private createChart() {
        this.chart = new Chart()

        const chartElement = this.getChartElement()

        if (!chartElement) {
            return
        }

        const parentElement = chartElement.parentElement!
        this.chart.create(chartElement, parentElement.clientWidth, this.props.height, dateFormatter, 'Occurrences')
        this.updateChart()
    }

    private getChartElement = () => this.svgRef.current

    private setResizeObserver = () => {
        const chartElement = this.getChartElement()
        if (chartElement) {
            const parentNode = jQuery(chartElement).parent()
            this.resizeObserver = observeElement(parentNode[0], this.rebuildChart)
        }
    }

    private rebuildChart = () => {
        this.destroyChart()
        this.createChart()
        if (this.chart) this.updateChart()
    }

    private destroyChart() {
        this.chart?.destroy() // remove svg-elements from dom
        this.chart = null // remove reference to the object
    }

    public componentDidMount() {
        if (!this.chart) {
            this.createChart()
        }
    }

    public componentDidUpdate() {
        if (!this.chart) {
            this.createChart()
        }

        if (!this.resizeObserver && this.chart) {
            this.setResizeObserver()
        }

        if (this.props.occurrences) {
            this.updateChart()
        }
    }

    public componentWillUnmount() {
        this.destroyChart()

        const chartElement = this.getChartElement()
        if (chartElement) {
            const parentNode = jQuery(chartElement).parent()
            if (parentNode[0]) {
                unobserveElement(parentNode[0])
            }
        }
    }
    public updateChart = () => {
        this.chart.update(
            [
                this.props.occurrences.map(occurrence => ({
                    x: moment(occurrence.start + 'Z').toDate(),
                    end: moment(occurrence.end + 'Z').toDate(),
                    y: occurrence.count,
                })),
            ],
            null,
            dateFormatter,
        )
    }

    public render() {
        return (
            <>
                <ErrorHistogramTimerangeSelector errorGroupId={this.props.errorGroupId} />
                <div className="erroroccurances">
                    <svg ref={this.svgRef} style={{ height: this.props.height }} />
                </div>
            </>
        )
    }
}
